module.exports = global["$"] = require("-!/private/tmp/deployer/releases/20170726155458/themes/app/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 0
// module chunks = 0